import React, { useState, useContext } from 'react';

import es from '../../constants/es';
import en from '../../constants/en';
import bg from '../../constants/bg';
import nl from '../../constants/nl';
import de from '../../constants/de';
import fr from '../../constants/fr';
import it from '../../constants/it';
import pl from '../../constants/pl';
import pt from '../../constants/pt';
import ro from '../../constants/ro';
import si from '../../constants/si';
import hu from '../../constants/hu';

import flag_es from '../../img/flag/es.jpg';
import flag_en from '../../img/flag/en.jpg';
import flag_bg from '../../img/flag/bg.jpg';
import flag_nl from '../../img/flag/nl.svg';
import flag_de from '../../img/flag/de.jpg';
import flag_fr from '../../img/flag/fr.jpg';
import flag_it from '../../img/flag/it.jpg';
import flag_pl from '../../img/flag/pl.jpg';
import flag_pt from '../../img/flag/pt.png';
import flag_ro from '../../img/flag/ro.jpg';
import flag_si from '../../img/flag/si.png';

export const LanguageData = {
  lang: "langFURNCIRCLE"
}

export const dictionaryList = {
  es, en, bg, nl, de, fr, it, pl, pt, ro, si, hu
};

export const languageOptions = [
  { id: 'es', text: 'Español', image: flag_es },
  { id: 'en', text: 'English', image: flag_en },
  { id: 'bg', text: 'български', image: flag_bg },
  { id: 'de', text: 'Deutsch', image: flag_de },
  { id: 'fr', text: 'Français', image: flag_fr },
  { id: 'it', text: 'Italiano', image: flag_it },
  { id: 'hu', text: 'Magyar', image: flag_si },
  { id: 'nl', text: 'Nederlands', image: flag_nl },
  { id: 'pl', text: 'Polski', image: flag_pl },
  { id: 'pt', text: 'Português', image: flag_pt },
  { id: 'ro', text: 'Română', image: flag_ro },
  { id: 'si', text: 'Slovenščina', image: flag_si },
];

export const getCookieLang = () => {
  let lang = localStorage.getItem(LanguageData.lang);
  if (lang && languageOptions.filter(language => language.id == lang).length > 0) {
    const selectedLang = languageOptions.filter(language => language.id == lang)[0];
    return { language: selectedLang, dictionary: dictionaryList[selectedLang.id] };
  }

  return {
    language: navigator.language.includes("es") ? languageOptions[0] : languageOptions[1],
    dictionary: dictionaryList[navigator.language.includes("es") ? languageOptions[0].id : languageOptions[1].id]
  }
}

export const LanguageContext = React.createContext(getCookieLang());

// it provides the language context to app
export function LanguageProvider(props) {
  const languageContext = useContext(LanguageContext);
  const [language, setLanguage] = useState(languageContext.language);
  const [dictionary, setDictionary] = useState(languageContext.dictionary);

  const provider = {
    language,
    dictionary,
    setLanguage: (selectedLanguage) => {
      setLanguage(selectedLanguage); // it will update the language in state
      setDictionary(dictionaryList[selectedLanguage.id]);
    },
  };

  return <LanguageContext.Provider value={provider} children={props.children} />;
};

export const getTextLang = (item, param, language) => {
  let value = item[`${param}${language.id !== 'en' ? `_${language.id.toUpperCase()}` : ''}`];
  return value == undefined ? item[param] : value;
}